import React, { useEffect, useState } from 'react';
import {
  Col,
  Form,
  Input,
  Row,
  Select,
  Button,
  Grid,
  InputNumber,
  Spin,
  Switch,
  notification,
  Tabs,
  Space
} from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useConfigQuery } from '../../../../queries/useConfig';
import axiosInstance from '../../../../axiosInterceptor';
import MoneyBRLRightToLeft from '../../../../Componentes/MoneyBRLRightToLeft';

// IMPORTS DAS NOVAS ABAS
import MarketplaceTab from './MarketplaceTab';
import ProductPhotosTab from './ProductPhotosTab';
import EmbalagensDeProduto from './EmbalagensDeProduto';

const { useBreakpoint } = Grid;

const FormularioDeProdutos = ({ onClose, produto, setProduto, setProducts, onSaved }) => {
  const { data: config, error } = useConfigQuery();
  const [form] = useForm();
  const ntipoItem = Form.useWatch('ntipoItem', form);
  const isCombustivel = String(ntipoItem ?? '') === '4';
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [categorias, setCategorias] = useState([]);
  const [categoriaPronta, setCategoriaPronta] = useState(false);
  const accessToken = window.localStorage.getItem("accessToken");
  const [isLoading, setIsLoading] = useState(false);
  const [produtoFormulario, setProdutoFormulario] = useState(null);

  useEffect(() => {
    if (config?.idLoja) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };
      axiosInstance
        .get(`https://techfood-api.herokuapp.com/v1/categorias/restaurante/${config?.idLoja}`, options)
        .then(restaurante => setCategorias(restaurante.data))
        .finally(() => setCategoriaPronta(true));
    }
  }, [config?.idLoja]);

  /*useEffect(() => {
    if (produto?.weight != null) {
      form.setFieldValue('weight', produto.weight / 1000);
    } else {
      form.setFieldValue('weight', 0);
    }
  }, [produto?.weight, form]);*/


  const BlocoCombustivel = ({ form }) => {
    const ntipoItem = Form.useWatch('ntipoItem', form);
    const isCombustivel = String(ntipoItem ?? '') === '4';
    return (
      <Row gutter={16}>
        <legend
          style={{
            borderTop: '1px solid #000',
            margin: 0,
            borderBottom: 0,
            borderLeft: 0,
            borderRight: 0,
            fontWeight: 'bold',
            color: '#000',
            display: isCombustivel ? 'block' : 'none',
          }}
        >
          Combustível
        </legend>

        <Col xs={24} lg={12}>
          <Form.Item label="pgnn" name="pgnn" hidden={!isCombustivel}>
            <InputNumber style={{ width: '100%' }} placeholder="Ex.: 18" />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item label="pgni" name="pgni" hidden={!isCombustivel}>
            <InputNumber style={{ width: '100%' }} placeholder="Ex.: 10" />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item label="pbio" name="pbio" hidden={!isCombustivel}>
            <Input placeholder="Ex.: 50" />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item label="cprodAnp" name="cprodAnp" hidden={!isCombustivel}>
            <InputNumber style={{ width: '100%' }} placeholder="Ex.: 5" />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item label="pglp" name="pglp" hidden={!isCombustivel}>
            <Input placeholder="Ex.: 01" />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item label="vpart" name="vpart" hidden={!isCombustivel}>
            <InputNumber style={{ width: '100%' }} placeholder="Ex.: 1.65" />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item
            label="Descrição do Produto conforme ANP"
            name="descAnp"
            hidden={!isCombustivel}
          >
            <Input placeholder="Ex.: 01" />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item label="ufConst" name="ufConst" hidden={!isCombustivel}>
            <Input style={{ width: '100%' }} placeholder="Ex.: 7.6" />
          </Form.Item>
        </Col>
      </Row>
    );
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1>{produto?.id ? `Editar Produto - ${produto.nome}` : `Criar Produto`}</h1>
      </header>

      {isLoading ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40, width: '100%' }}>
          <Spin spinning={isLoading} size="large" />
          <span style={{ marginTop: 16, fontSize: 14, color: '#666' }}>{'Carregando...'}</span>
        </div>
      ) : (
        <Tabs defaultActiveKey="1" destroyInactiveTabPane={false}>
          {/* ABA 1 - GERAL (mantive tudo exatamente como estava) */}
          <Tabs.TabPane tab="Principal" key="1">
            <Form
              autoComplete="off"
              layout={isMobile ? 'vertical' : 'horizontal'}
              labelAlign="left"
              form={form}
              labelCol={isMobile ? undefined : { span: 7 }}
              wrapperCol={isMobile ? undefined : { span: 17 }}
              initialValues={
                produto
                  ? {
                    ...produto,
                    custo: produto.custo ?? 0
                  }
                  : {
                    custo: 0,
                    ean: 'SEM GTIN',
                    unidade: 'UN',
                    cfop: '5102',
                    cst: '102',
                    weight: 0,
                    predBc: 0,
                    picms: 0,
                    cstPis: '07',
                    cstCofins: '07',
                    cclassTrib: '000001',
                    ibscbsCst: '000',
                    pibsuf:0.1,
                    pcbs:0.9,
                    pibsMun:0
                  }
              }
              onFinish={async (formProduto) => {


                console.log(formProduto);


                /*if (formProduto.weight) {
                  formProduto.weight = formProduto.weight * 1000;
                }*/

                console.log(formProduto);

                setIsLoading(true);
                formProduto.categoria = formProduto.idCategoria;
                delete formProduto.idCategoria;
                if (!formProduto.unidadeTributavel) {
                  formProduto.unidadeTributavel = formProduto.unidade;
                }

                const options = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                  },
                };

                if (formProduto.ean) {
                  if (formProduto.ean.trim() === '') formProduto.ean = 'SEM GTIN';
                } else {
                  formProduto.ean = 'SEM GTIN';
                }

                // Editar produto
                if (produto?.id) {
                  try {

                    const resp = await axiosInstance.put(
                      `https://techfood-api.herokuapp.com/v1/restaurantes/${config?.idLoja}/produtos/${produto?.id}`,
                      formProduto,
                      options
                    );
                    notification.success({
                      message: 'Sucesso',
                      description: 'Produto editado com sucesso!!',
                    });
                    setIsLoading(false);
                    setProducts(prev =>
                      prev.map(p => String(p.id) === String(resp.data.id) ? resp.data : p)
                    );
                    setProduto(resp.data);
                    //onClose();
                  } catch (error) {
                    setIsLoading(false);
                    console.error(error);
                  }
                } else {
                  try {
                    if (form.ativo === undefined) {
                      formProduto.ativo = true;
                    }
                    const resp = await axiosInstance.post(
                      `https://techfood-api.herokuapp.com/v1/restaurantes/${config?.idLoja}/produtos`,
                      formProduto,
                      options
                    );
                    notification.success({
                      message: 'Sucesso',
                      description: 'Produto criado com sucesso!!',
                    });
                    setIsLoading(false);
                    setProducts(prev => [...prev, resp.data]);
                    if (resp.data) {
                      setProduto(resp.data);
                    }

                    //onClose();
                  } catch (error) {
                    console.error(error);
                    setIsLoading(false);
                  }
                }
              }}
              className="product-form"
            >
              {/* Linha 1: Nome / Descrição */}
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Nome"
                    name="nome"
                    rules={[
                      { required: true, message: 'O campo é obrigatório' },
                      { max: 255, message: `O nome não pode ter mais de 255 caracteres` },
                    ]}
                  >
                    <Input placeholder="E.x.: xxxxxxxxxxxx" allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Descrição"
                    name="descricao"
                    rules={[
                      { required: true, message: 'O campo é obrigatório' },
                      { max: 255, message: `A descrição não pode ter mais de 255 caracteres` },
                    ]}
                  >
                    <Input placeholder="E.x.: xxxxxxxxxxx" allowClear />
                  </Form.Item>
                </Col>
              </Row>

              {/* Linha 2: Preço & Custo  |  EAN & Unidade */}
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  <Row gutter={[16, 12]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Valor"
                        name="preco"
                        rules={[{ required: true, message: "Informe o preço" }]}
                      >
                        <MoneyBRLRightToLeft />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Custo"
                        name="custo"
                      >
                        <MoneyBRLRightToLeft />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col xs={24} md={12}>
                  <Row gutter={[16, 12]}>
                    <Col xs={24} md={12}>
                      <Form.Item label="EAN" name="ean" className="form-item--compact">
                        <Input placeholder="E.x.: 5265" allowClear defaultValue={"SEM GTIN"} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item label="Unidade" name="unidade" className="form-item--compact">
                        <Input placeholder="E.x.: UN" defaultValue={"UN"} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* Linha 3: NCM / CFOP */}
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  <Form.Item label="NCM" name="ncm">
                    <Input type="number" placeholder="E.x.: 19059010" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="CFOP" name="cfop">
                    <Input type="number" placeholder="E.x.: 5102" defaultValue={"5102"} />
                  </Form.Item>
                </Col>
              </Row>

              {/* Linha 4: Código | NtipoItem & CST */}
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  <Form.Item label="Código de Integração" name="codigo">
                    <Input placeholder="E.x.: xxxxxxxxxxxxx" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Row gutter={[16, 12]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="NtipoItem"
                        name="ntipoItem"
                        initialValue="0"
                        className="form-item--compact"
                      >
                        <Select placeholder="Tipo do item" showSearch optionFilterProp="children">
                          <Select.Option value="0">0 - Produtos</Select.Option>
                          <Select.Option value="1">1 - Veículos</Select.Option>
                          <Select.Option value="2">2 - Medicamentos</Select.Option>
                          <Select.Option value="3">3 - Armamentos</Select.Option>
                          <Select.Option value="4">4 - Combustível</Select.Option>
                          <Select.Option value="5">5 - Serviço</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item label="Cst" name="cst" className="form-item--compact">
                        <Input type="number" placeholder="E.x.: 102" defaultValue={"102"} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* Linha 5: Origem / Categoria */}
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  <Form.Item label="Origem" name="origem" initialValue="0">
                    <Select placeholder="Origem da mercadoria" showSearch optionFilterProp="children">
                      <Select.Option value="0">0 - Nacional - Exceto as indicadas nos códigos 3,4,5 e 8</Select.Option>
                      <Select.Option value="1">1 - Estrangeira - Importação Direta</Select.Option>
                      <Select.Option value="2">2 - Estrangeira - Adq. no mercado interno</Select.Option>
                      <Select.Option value="3">3 - Nacional - Conteúdo de Importação &gt; 40% e ≤ 70%</Select.Option>
                      <Select.Option value="4">4 - Nacional - produção em conformidade</Select.Option>
                      <Select.Option value="5">5 - Nacional - Conteúdo de Importação ≤ 40%</Select.Option>
                      <Select.Option value="6">6 - Estrangeira - Imp. direta, sem similar, lista CAMEX</Select.Option>
                      <Select.Option value="7">7 - Estrangeira - Adq. interno, sem similar, lista CAMEX</Select.Option>
                      <Select.Option value="8">8 - Nacional - Conteúdo de Importação &gt; 70%</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label={'Categoria'}
                    name={'idCategoria'}
                    style={{ width: '100%' }}
                    rules={[{ required: true, message: 'O campo é obrigatório' }]}
                  >
                    <Select placeholder={'Selecione a categoria'} showSearch optionFilterProp='children' disabled={produto?.temMkt}>
                      {categorias?.map((categoria) => (
                        <Select.Option key={categoria.id} value={categoria.id}>
                          {categoria.nome}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* CAMPOS EXTRAS (mantidos na aba Geral) */}
                <Row gutter={16} style={{ width: '100%' }}>
                  <Col xs={24} lg={8}>
                    <Form.Item label="Brand" name="brandMkt">
                      <Input style={{ width: '100%' }} placeholder="Ex.: Marca" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={8}>
                    <Form.Item label="Cest" name="cest">
                      <Input style={{ width: '100%' }} placeholder="Ex.: 7.6" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={8}>
                    <Form.Item label="Sku" name="sku">
                      <Input style={{ width: '100%' }} placeholder="Ex.: 7.6" disabled={produto?.temMkt} />
                    </Form.Item>
                  </Col>





                  <Col xs={24} lg={6}>
                    <Form.Item label="Altura (cm)" name="height">
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="Ex.: 100" // Atualizado para usar vírgula no placeholder
                        // Transforma o valor numérico para exibição, usando vírgula
                        formatter={(value) => `${value}`.replace('.', ',')}
                        // Transforma o valor de exibição (com vírgula) para um número (com ponto)
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={6}>
                    <Form.Item label="Largura (cm)" name="width">
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="Ex.: 100" // Atualizado para usar vírgula no placeholder
                        formatter={(value) => `${value}`.replace('.', ',')}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={6}>
                    <Form.Item label="Comprimento (cm)" name="length">
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="Ex.: 100" // Atualizado para usar vírgula no placeholder
                        formatter={(value) => `${value}`.replace('.', ',')}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={6}>
                    <Form.Item label="Peso (kg)" name="weight">
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="Ex.: 7,6" // Atualizado para usar vírgula no placeholder
                        defaultValue={0}
                        formatter={(value) => `${value}`.replace('.', ',')}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                  </Col>


                </Row>

                <Row gutter={16} style={{ width: '100%' }}>
                  <legend
                    style={{
                      borderTop: '1px solid #000',
                      margin: '0',
                      borderBottom: '0',
                      borderLeft: '0',
                      borderRight: '0',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  >
                    Imposto
                  </legend>

                  <Col xs={24} lg={12}>
                    <Form.Item label="Alíquota % do ICMS" name="picms">
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="Ex.: 7,6" // Atualizado para usar vírgula no placeholder
                        defaultValue={0}
                        formatter={(value) => `${value}`.replace('.', ',')}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item label="Redução da Base de Cálculo (predBc)" name="predBc">
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="Ex.: 7,6" // Atualizado para usar vírgula no placeholder
                        defaultValue={0}
                        formatter={(value) => `${value}`.replace('.', ',')}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item label="CST do IPI" name="cstIpi">
                      <Input placeholder="Ex.: 50" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item label="Alíquota do IPI" name="pipi">
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="Ex.: 7,6" // Atualizado para usar vírgula no placeholder
                        defaultValue={0}
                        formatter={(value) => `${value}`.replace('.', ',')}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item label="CST do PIS" name="cstPis" >
                      <Input placeholder="Ex.: 01" defaultValue={"07"} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item label="Alíquota do PIS" name="ppis">
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="Ex.: 7,6" // Atualizado para usar vírgula no placeholder
                        defaultValue={0}
                        formatter={(value) => `${value}`.replace('.', ',')}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item label="CST do Cofins" name="cstCofins">
                      <Input placeholder="Ex.: 01" defaultValue={"07"} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item label="Alíquota do Cofins" name="pcofins">
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="Ex.: 7,6" // Atualizado para usar vírgula no placeholder
                        defaultValue={0}
                        formatter={(value) => `${value}`.replace('.', ',')}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item label="Alíquota ICMS Retido (Ad Rem)" name="adRemIcmsRet">
                      <InputNumber
                        style={{ width: '100%' }}
                        placeholder="Ex.: 7,6" // Atualizado para usar vírgula no placeholder
                        defaultValue={0}
                        formatter={(value) => `${value}`.replace('.', ',')}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item label="Unidade Tributavel" name="unidadeTributavel">
                      <Input style={{ width: '100%' }} placeholder="Ex.: UN" />
                    </Form.Item>
                  </Col>
                </Row>

                <BlocoCombustivel form={form} />

                <legend
                  style={{
                    borderTop: '1px solid #000',
                    margin: '0',
                    borderBottom: '0',
                    borderLeft: '0',
                    borderRight: '0',
                    fontWeight: 'bold',
                    color: '#000',
                  }}
                >
                  Reforma Tributária
                </legend>

                <Col xs={24} lg={12}>
                  <Form.Item label="CST" name="ibscbsCst">
                    <Input style={{ width: '100%' }} placeholder="Ex.: 000" />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item label="cClassTrib" name="cclassTrib">
                    <Input style={{ width: '100%' }} placeholder="Ex.: 000001" />
                  </Form.Item>
                </Col>


                <Col xs={24} lg={12}>
                  <Form.Item label="pIBSUF" name="pibsuf">
                    <InputNumber
                      style={{ width: '100%' }}
                      placeholder="Ex.: 0,1000" // Atualizado para usar vírgula no placeholder
                      defaultValue={0}
                      formatter={(value) => `${value}`.replace('.', ',')}
                      parser={(value) => value.replace(',', '.')}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item label="pIBSMun" name="pibsMun">
                    <InputNumber
                      style={{ width: '100%' }}
                      placeholder="Ex.: 0,0000" // Atualizado para usar vírgula no placeholder
                      defaultValue={0}
                      formatter={(value) => `${value}`.replace('.', ',')}
                      parser={(value) => value.replace(',', '.')}
                    />
                  </Form.Item>
                </Col>
                                <Col xs={24} lg={12}>
                  <Form.Item label="pCBS" name="pcbs">
                    <InputNumber
                      style={{ width: '100%' }}
                      placeholder="Ex.: 0,9000" // Atualizado para usar vírgula no placeholder
                      defaultValue={0}
                      formatter={(value) => `${value}`.replace('.', ',')}
                      parser={(value) => value.replace(',', '.')}
                    />
                  </Form.Item>
                </Col>



              </Row>

              {/* Rodapé: botões à direita */}
              <div className="product-form__footer">
                <Space wrap size={12}>
                  <Button type="primary" htmlType="submit" className="btn-black">
                    Salvar Produto
                  </Button>

                  <Button
                    type={'primary'}
                    htmlType={'button'}
                    style={{
                      backgroundColor: produto ? 'red' : '#E5E5E5',
                      borderColor: produto ? 'red' : '#E5E5E5',
                    }}
                    disabled={!produto}
                    onClick={async () => {
                      try {
                        setIsLoading(true);
                        const options = {
                          headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + accessToken,
                          },
                        };
                        const respExclusão = await axiosInstance.delete(
                          `https://techfood-api.herokuapp.com/v1/restaurantes/${config?.idLoja}/produtos/${produto.id}/excluir`,
                          options
                        );
                        setIsLoading(false);
                        notification.success({
                          message: 'Sucesso',
                          description: 'Produto excluido com sucesso',
                        });
                        setProducts((prev) => prev.filter((p) => p.id !== produto.id));
                        onClose();
                      } catch (error) {
                        notification.error({
                          message: 'Falha',
                          description: 'Falha ao excluir com o produto',
                        });
                        setIsLoading(false);
                      }
                    }}
                  >
                    Excluir Produto
                  </Button>

                  <Form.Item name={'ativo'} valuePropName='checked' noStyle>
                    <Switch defaultChecked checkedChildren={'Ativo'} unCheckedChildren={'Inativo'} />
                  </Form.Item>
                </Space>
              </div>
            </Form>
          </Tabs.TabPane>

          {/* ABA 2 - MARKETPLACE (cards + botão novo) */}
          <Tabs.TabPane tab="Imagens" key="2">
            <ProductPhotosTab produto={produto} onSaved={onSaved} />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Embalagens" key="4" disabled={!produto}>
            <EmbalagensDeProduto produto={produto} onSaved={onSaved} />
          </Tabs.TabPane>

          {/* ABA 3 - FOTOS (upload, preview, grid) */}
          <Tabs.TabPane tab="MarketPlace" key="3" disabled={!produto || !produto?.sku || produto?.preco == 0 || (!produto?.img1 && !produto?.img2 && !produto?.img3 && !produto?.img4)}>
            <MarketplaceTab produto={produto} setProduto={setProduto} />
          </Tabs.TabPane>
        </Tabs>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "16px",
    maxWidth: "100%",
    margin: "0 auto",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
};

export default FormularioDeProdutos;
